import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { WebShopService } from "../../services/webShop.service";
import { WebShopMode } from "../../services/IWebShopService";
import { CoreLogService } from "../../services/log.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CheckoutPaymentModel, CompletePurchaseOrderItemModel, ResponseCode_Done } from "../../shared/models/checkout.model";
import { CoreLanguageService } from "../../services/language.service";
import * as _ from "lodash";
import { WebVoucherService } from "../../services/web_voucher.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs";
import { CoreCOMService } from "../../services/com.service";
import { LastOrderInfo, CheckoutService } from "../../services/checkout.service";
import { environment } from "../../../../environments/environment";
import { DateFormatTyps, VoucherServiceType } from "../../shared/contentTypes";
import { orderTypes } from "../../shared/models/webshop.model";
import DateManager from "../../shared/dateManager";
import Utils from "../../shared/utils";
import { CoreOpenDayTime } from "../../languages/openDayTime";
import { DayOfWeek } from "../../shared/models";
import { UserHelperService } from "../../services/userHelper.service";
import { ChefCampaignsService } from "../../services/ChefCampaignsService";
import { customConfig } from "../../../custom/custom-config";
import { ExternalLinksSettingsService } from "../../services/ExternalLinksSettings.service";
import { TrackingManager } from "../../services/tracking/tracking-manager";

/** representiert einen Kundeneigenen Button zu einer Landingpage */
class CustomLandingPageButton {
  label_de: string;
  label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  url_de: string;
  url_en: string;
  public get url(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.url_en) ? this.url_de : this.url_en;
  }
}

class Ticket {
  nr: number;
  valid_date_start_ymd: number;
  valid_date_start_hms: number;
  valid_date_end_ymd: number;
  valid_date_end_hms: number;
  label: string;
  amount: number;
  factor: number; // How many times is this ticket usable
  pdf: string;
  walletReferenceId: string;
  isActive: boolean;
}

class Webvoucher {
  nr: number;
  amount: number;
  pdf: string;
  formattedPrice: string;
  label_de: string;
  label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  displayPersonCount: boolean;
  personCount: number;
  delivery: number;
  walletReferenceId: string;
  isActive: boolean;
}

@Component({
  selector: "ya-orderresult",
  templateUrl: "./orderresult.component.html",
  styleUrls: ["./orderresult.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderResultComponent implements OnInit, OnDestroy {

  public checkoutpaymentmodel: CheckoutPaymentModel;
  public ResponseCode_Done = ResponseCode_Done;
  public webShopMode = WebShopMode;
  public service: WebShopMode;
  public voucherservice: VoucherServiceType;
  public voucherserviceType = VoucherServiceType;

  /** shows the order name once the service mode is known, unless the order type hides it */
  public get showOrderName(): boolean {
    const me = this;
    // undefined means initialize() has not run yet; a resolved-but-null service must still show the name
    return me.service !== undefined &&
      !!(me.checkoutpaymentmodel && me.checkoutpaymentmodel.table_name) &&
      me.service !== WebShopMode.OrderToTable &&
      me.service !== WebShopMode.Retail &&
      me.service !== WebShopMode.Ticket &&
      me.service !== WebShopMode.Webvoucher;
  }

  public lastOrderInfo: LastOrderInfo;
  private _localeChangeSubscription: Subscription;
  private _isWebshopFullyLoadedSubscription: Subscription;
  private _userLoginSubscription: Subscription;

  public confirmationmailtext: string = "";
  /** raw value — render only via the pre-escaped confirmationmailtext/voucherconfirmationmailSend, never [innerHTML] or bypassSecurityTrust* */
  public mail: string = "";
  public ordersuccesstext: string = "";
  public phonenumber: string = "";
  public bonuspointsHTMLs: string[] = [];
  public voucherconfirmationmailSend: string = "";
  public tickets: Ticket[] = [];
  public webvouchers: Webvoucher[] = [];
  public isMobile: boolean = false;
  public get showReturnToHomeBtn(): boolean {
    return this.returnURL.length === 0;
  }
  public get showReturnToURLBtn(): boolean {
    return this.returnURL.length > 0;
  }
  public returnURL: string = "";

  constructor(private _webShopService: WebShopService
    , public _userHelperService: UserHelperService
    , private _checkoutService: CheckoutService
    , private _internationalisationService: InternationalisationService
    , private _activatedRoute: ActivatedRoute
    , private _coreCOMService: CoreCOMService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _router: Router
    , private _chefCampaignsService: ChefCampaignsService
    , private _trackingManager: TrackingManager
    , private _externalLinksSettingsService: ExternalLinksSettingsService
    , private _webVoucherService: WebVoucherService
  ) {
  }

  ngOnInit() {
    const me = this;
    me.isMobile = me._coreCOMService.environment.client.isMobile;
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData && routeTargetData["CheckoutPaymentModel"]) {
      me.checkoutpaymentmodel = routeTargetData["CheckoutPaymentModel"];

      me._checkoutService.getLastOrderInfo().then(lastOrderInfo => {
        if (lastOrderInfo == null) {
          me._coreLogService.info("OrderResultComponent.ngOnInit", "_checkoutService.getLastOrderInfo returned no lastOrderInfo, rendering with reduced data", { order_id: me.checkoutpaymentmodel.order_id, done: me.checkoutpaymentmodel.done });
        }
        me.lastOrderInfo = lastOrderInfo;
        me.returnURL = (lastOrderInfo != null) ?
          (me.checkoutpaymentmodel.done === ResponseCode_Done.Authorised ? lastOrderInfo.returnURLSuccess : lastOrderInfo.returnURLFail) : "";
        me.setLanguageBasedStrings().catch(e => {
          me._coreLogService.error("OrderResultComponent.ngOnInit.setLanguageBasedStrings", "setLanguageBasedStrings failed", e);
        });
        me._localeChangeSubscription = me._internationalisationService.localeChanged.subscribe(async () => {
          await me.setLanguageBasedStrings();
          me.PushChanges();
        });
        me._isWebshopFullyLoadedSubscription = me._webShopService.getFullyLoadedObservable.subscribe(async () => {
          try {
            await me.initialize();
          } catch (e) {
            me._coreLogService.error("OrderResultComponent.ngOnInit.isWebshopFullyLoadedSubscription", `initialize failed (service=${me.service}, order_id=${me.checkoutpaymentmodel.order_id})`, e);
          }
          me.PushChanges();
        });
        me._userLoginSubscription = me._userHelperService.RegisterObserver.subscribe((registered) => {
          if (registered && me.lastOrderInfo && me.lastOrderInfo.deliveryAddressViewModel && me.lastOrderInfo.deliveryAddressViewModel.id === "") {
            me._webShopService.saveNewCustomerFurtherAddress(me.lastOrderInfo.deliveryAddressViewModel);
          }
        });
        const currencySymbol = me._webShopService.currencySymbol ? me._webShopService.currencySymbol : "€";
        me._chefCampaignsService.addSalesEventScriptIfActive(document.body, me.checkoutpaymentmodel.order_id, me.checkoutpaymentmodel.order_amount, currencySymbol);

        me.trackPurchase();
      }).catch(e => {
        me._coreLogService.error("OrderResultComponent.ngOnInit", "_checkoutService.getLastOrderInfo", e);
        me.PushChanges();
      });
    } else {
      // No Last Checkoutmodel, Redirect to StartPage and Replace Orderresult in History to make it skipable
      me._router.navigateByUrl("/", { replaceUrl: true, skipLocationChange: true })
      return;
    }
    if (me._userHelperService.IsRegistered) {
      console.log("Result page--> INIT Method");
    }

  }

  ngOnDestroy(): void {
    const me = this;
    if (me._localeChangeSubscription) {
      me._localeChangeSubscription.unsubscribe();
    }
    if (me._isWebshopFullyLoadedSubscription) {
      me._isWebshopFullyLoadedSubscription.unsubscribe();
    }
    if (me._userLoginSubscription) {
      me._userLoginSubscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("OrderResultComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  private async initialize() {
    const me = this;
    me.service = me._webShopService.getServiceMode()
    if (me.checkoutpaymentmodel.table_name && !me.showOrderName) {
      // expected for Retail/Ticket/Webvoucher; diagnostic only, never logs table_name (PII)
      me._coreLogService.info("OrderResultComponent.initialize", "table_name present but showOrderName suppressed it", { service: me.service });
    }
    if (me.service === WebShopMode.Webvoucher) {
      me.voucherservice = me._webShopService.voucherServiceType;
    }
    me.initializeCustomLandingPageBtn();
    await me.setLanguageBasedStrings();
    if (me.checkoutpaymentmodel.done === ResponseCode_Done.Authorised) {
      try {
        me._webShopService.resetWebshopService();
        await me._webShopService.removeCachedServiceTime();
      } catch (e) {
        // diagnostic only; scope of what's still stale depends on which of the two calls above threw
        me._coreLogService.error("OrderResultComponent.initialize.cleanupAfterAuthorised", "cleanupAfterAuthorised threw (resetWebshopService or removeCachedServiceTime), cached serviceTime storage key may not have been cleared", e);
      }
    }
  }

  /** wenn es einen CustomLandingPageButton gibt wird er hier gebuffert */
  private _customLandingPageBtn: CustomLandingPageButton = null;

  /** initialisiert aus der CustomConfig.custom_json den Custom LandingPage Button */
  private initializeCustomLandingPageBtn(): void {
    const me = this;
    try {
      const cus_json = customConfig.custom_json;
      if (cus_json) {
        const cus_json_obj: { order_result_btns: { order_type: number, label_de: string, label_en: string, url_de: string, url_en: string }[] } = JSON.parse(cus_json);
        if (cus_json_obj.order_result_btns) {
          const service_button = cus_json_obj.order_result_btns.find((btn) => btn.order_type === me.service);
          if (service_button) {
            const custom_btn = new CustomLandingPageButton();
            // egal ob de oder en, wenn nur eine Sprache vorhanden ist, wird diese verwendet
            custom_btn.label_de = service_button.label_de || service_button.label_en;
            custom_btn.label_en = service_button.label_en || service_button.label_de;
            custom_btn.url_de = service_button.url_de || service_button.url_en;
            custom_btn.url_en = service_button.url_en || service_button.url_de;
            // verwenden wen label und url vorhanden sind
            if (custom_btn.label && custom_btn.url && me.lastOrderInfo != null) {
              const replace_parts: { key: string, value: string }[] = [];
              replace_parts.push({ key: "{HypCusNo}", value: me.lastOrderInfo.location.toString() });
              replace_parts.push({ key: "{OrderID}", value: me.lastOrderInfo.id });
              replace_parts.push({ key: "{OrderToken}", value: me.lastOrderInfo.token || "" });

              for (const part of replace_parts) {
                custom_btn.label_de = custom_btn.label_de.replace(part.key, part.value);
                custom_btn.label_en = custom_btn.label_en.replace(part.key, part.value);
                custom_btn.url_de = custom_btn.url_de.replace(part.key, part.value);
                custom_btn.url_en = custom_btn.url_en.replace(part.key, part.value);
              }
              me._customLandingPageBtn = custom_btn;
            } else if (me.lastOrderInfo == null) {
              me._coreLogService.error("OrderResultComponent.initializeCustomLandingPageBtn", "lastOrderInfo missing, cannot fill button placeholders", service_button);
            } else {
              me._coreLogService.error("OrderResultComponent.initializeCustomLandingPageBtn", "service_button has no values", service_button);
            }
          } // else no button for Service
        } // else no order_result_btns
      } // else no custom json
    } catch (error) {
      me._coreLogService.error("OrderResultComponent.initializeCustomLandingPageBtn", "catch", error);
    }
  }

  /** soll der CustomLandingPageBtn dargestellt werden */
  public get showCustomLandingPageBtn(): boolean {
    return this._customLandingPageBtn !== null;
  }

  /** stellt den Text für den Custom Landingpage Button bereit */
  public get customLandingPageBtnText(): string {
    return this._customLandingPageBtn.label;
  }

  /** navigiert nach dem Klick auf die Custom Landingpage */
  public clickCustomLandingPage(): void {
    this._externalLinksSettingsService.RouteToExternalLinks(this._customLandingPageBtn.url, true);
  }

  private async setLanguageBasedStrings() {
    const me = this;
    // runs even without lastOrderInfo — reads only checkoutpaymentmodel/language service
    me.setBonusPoints();
    if (me.lastOrderInfo == null) {
      return;
    }
    me.phonenumber = me.lastOrderInfo.locTele;
    me.setMailText();
    await me.setOrderText();
  }

  private setMailText() {
    const me = this;
    me.mail = me.lastOrderInfo.customerMail;
    // replacer must stay a function — a string replacement value reinterprets $&/$$/$'/$` from the escaped value
    me.confirmationmailtext = _.escape(me._coreLanguageService.value("phOrderResult_ConfirmationMailSend_TEXT"))
      .replace("{email}", () => `<span class="emphasized">${_.escape(me.mail)}</span>`);
    me.voucherconfirmationmailSend = _.escape(me._coreLanguageService.value("phOrderResult_SuccessWebvoucher_ConfirmationMailSend"))
      .replace("{email}", () => `<span class="emphasized">${_.escape(me.mail)}</span>`);
  }

  private async setOrderText() {
    const me = this;
    const ordertype = me.lastOrderInfo.ordertype;
    if (ordertype != null) {
      // order_id is a NoCOOCode-Pin composite (not the real order id) when nocoo is set; skip the id-match check in that case
      const isNoCOOOrder = !Utils.IsNullOrEmpty(me.checkoutpaymentmodel.nocoo);
      // guards against a stale lastOrderInfo from a different order (shared terminal)
      if (!isNoCOOOrder && me.lastOrderInfo.id !== me.checkoutpaymentmodel.order_id) {
        return;
      }
      const asap = me.lastOrderInfo.handoverDate < 0;
      const hour = Math.floor(me.lastOrderInfo.handoverTime / 10000 % 100);
      const minute = ("00" + Math.floor(me.lastOrderInfo.handoverTime / 100 % 100)).slice(-2);
      let day = "";
      let webshopSetting = null;
      try {
        webshopSetting = await me._webShopService.getWebshopSettingsDataModel();
      } catch (e) {
        me._coreLogService.error("OrderResultComponent.setOrderText", "getWebshopSettingsDataModel failed, rendering without the day-prefix", e);
      }
      if (!asap && (ordertype === orderTypes.delivery || ordertype === orderTypes.pickup) && webshopSetting && webshopSetting.order_day_limit && webshopSetting.order_day_limit > 0) {
        const phOrderResult_DayAtPrefix = me._coreLanguageService.value("phOrderResult_DayAtPrefix");
        const momentorderDate = Utils.GetMomentFromInt(me.lastOrderInfo.handoverDate);
        const dicOpenDayTime = CoreOpenDayTime[InternationalisationService.locale];
        const weekdayName: string = Utils.EnumName(DayOfWeek, momentorderDate.isoWeekday());
        const phWeekdayName: string = dicOpenDayTime[`ph${weekdayName}Full`];
        day = ` ${phOrderResult_DayAtPrefix} ${phWeekdayName}, ${momentorderDate.format("DD.MM.YYYY")}`;
      }
      // TODO Make Function to create moment from ymd+hms and then use moment to get formatted time
      const street = me.lastOrderInfo.handoverStreet || "";
      const orderid = me.lastOrderInfo.id;
      let placeholder: string;
      const hasStreet = (street && street.length > 0);
      // persisted ordertype instead of the volatile service mode (null after redirect); an unmatched type renders nothing rather than the wrong direction
      switch (ordertype) {
        case orderTypes.delivery:
          placeholder = (hasStreet) ? "phOrderResult_SuccessDelivery_BASE" : "phOrderResult_SuccessDelivery_BASE_Nostreet"; break;
        case orderTypes.pickup:
          placeholder = (hasStreet) ? "phOrderResult_SuccessPickup_BASE" : "phOrderResult_SuccessPickup_BASE_Nostreet"; break;
        case orderTypes.inHouse:
          placeholder = "phOrderResult_SuccessInHause_BASE"; break;
      }
      me.setOrderSuccessText(placeholder, orderid, day, hour, minute, asap, street);
      if ((me.checkoutpaymentmodel.items == null) || (me.checkoutpaymentmodel.items.length === 0)) {
        // fängt null und undefined ab
      } else {
        me.tickets = [];
        me.webvouchers = [];
        for (const item of me.checkoutpaymentmodel.items) {
          me.tickets = me.tickets.concat(me.extractTickets(item.ticketnumbers, item));
          me.webvouchers = me.webvouchers.concat(me.extractWebvouchers(item.webvouchernumbers, item));
        }
      }
    }
  }

  private trackPurchase(): void {
    if (!this.lastOrderInfo || !this.lastOrderInfo.orderedItems || !this.lastOrderInfo.orderedItems.length) return;

    this._trackingManager.trackPurchase(
      this.lastOrderInfo.id,
      this.lastOrderInfo.orderedItems,
      this._webShopService.currencySymbol,
      this._webShopService.getBasketSumTotal(),
      this._webShopService.finalDeliveryFee,
    );
  }

  public formatDate(date: number, dateformattype: string = "DDMMYYYY") {
    return DateManager.MomentAsString(Utils.GetMomentFromInt(date), DateFormatTyps[dateformattype]);
  }

  /**set orderresult text for Delivery, Takeaway and webvoucher */
  private setOrderSuccessText(placeholder: string, orderid: string, day: string, hour: number, minute: string, asap: boolean, street: string = "") {
    const me = this;
    if (placeholder) {
      // substituted values need their own escaping — the langkey escape above doesn't cover them, and this is bound via [innerHTML]
      let orderText = _.escape(me._coreLanguageService.value(placeholder))
        .replace("{orderid}", () => `<span class="emphasized">Nr. ${_.escape(orderid)}</span>`);

      if (asap) {
        const asapText = me._coreLanguageService.value("phOrderResult_AsSoonAsPossible");
        orderText = orderText.replace("{day}", "")
          .replace("{time}", () => `<span class="emphasized">${asapText}</span>`);
      } else {
        const timeAboutPrefix = me._coreLanguageService.value("phOrderResult_TimeAboutPrefix");
        orderText = orderText.replace("{day}", () => `<span class="emphasized">${day}</span>`)
          .replace("{time}", () => `${timeAboutPrefix} <span class="emphasized">${hour}:${minute}</span>`);
      }

      if (street) {
        orderText = orderText.replace("{street}", () => `<span class="emphasized">${_.escape(street)}</span>`);
      }
      me.ordersuccesstext = orderText;
    } else {
      me.ordersuccesstext = "";
    }
  }

  public loadVoucherPDF() {
    this.loadPdf(this.webvouchers, "VoucherHandler");
  }

  public loadTicketPDF() {
    this.loadPdf(this.tickets, "TicketHandler");
  }

  private loadPdf(data: (Ticket | Webvoucher)[], dataName: string) {
    if ((data !== null && data.length > 0 && data[0].pdf.length > 0)) {
      const link = environment.YourAppServer.BaseURI + dataName + ".ashx?ON=" + data[0].pdf;
      window.open(link, "_system");
    }
  }

  private extractWebvouchers(s: string, item): Webvoucher[] {
    const me = this;
    const webvouchers: Webvoucher[] = [];
    const properties = s.split("|");

    const walletReferences = Utils.IsNullOrEmpty(item.webvoucherwalletreferences)
      ? []
      : item.webvoucherwalletreferences.split(",");

    if (properties.length === 3) {
      const nrs = properties[0].split(",");
      const amount = properties[1].split(",");
      const pdfs = properties[2].split(",");

      for (let i = 0; i < nrs.length; i++) {
        const webvoucher = new Webvoucher();
        webvoucher.nr = +nrs[i];
        webvoucher.walletReferenceId = walletReferences[i] || "";
        webvoucher.amount = +amount[i];
        webvoucher.pdf = pdfs[i];
        webvoucher.formattedPrice = me._webShopService.formatCurrency(webvoucher.amount);
        webvoucher.label_de = item.webvouchername_de;
        webvoucher.label_en = item.webvouchername_en;
        webvoucher.isActive = item.walletactive;
        webvoucher.delivery = item.webvoucherdelivery;
        webvoucher.displayPersonCount = item.webvouchershowpersoncount;
        webvoucher.personCount = item.webvoucherpersoncount;
        webvouchers.push(webvoucher);
      }
    }
    return webvouchers;
  }

  public get isWebVoucherMailDelivery(): boolean {
    const me = this;
    let mailDelivery = 0;
    return me.webvouchers.filter(i => i.delivery === mailDelivery).length > 0 ? true : false;
  }

  public addToWallet(walletReferenceId: string, passType: "Ticket" | "Voucher", platform: "Google" | "Apple") {
    this._webVoucherService.addToWallet(walletReferenceId, passType, platform).catch((e: any) => {
      this._coreLogService.error("OrderResultComponent.addToWallet", "WebVoucherService.addToWallet", e);
    });
  }

  public displayWebVoucherPerson(personCount: number) {
    const me = this;
    let minPersonCount = 1;
    return personCount > minPersonCount ? true : false;
  }

  private extractTickets(s: string, item: CompletePurchaseOrderItemModel): Ticket[] {
    const tickets: Ticket[] = [];
    const properties = s.split("|");

    const walletReferences = Utils.IsNullOrEmpty(item.ticketwalletreferences)
      ? []
      : item.ticketwalletreferences.split(",");

    if (properties.length === 9) {
      const nrs = properties[0].split(",");
      const valid_date_start_ymd = properties[1].split(",");
      const valid_date_end_ymd = properties[2].split(",");
      const valid_date_start_hms = properties[3].split(",");
      const valid_date_end_hms = properties[4].split(",");
      const labels = properties[5].split(",");
      for (let label of labels) { // , are encoded as \\-//
        label = label.replace("\\-//", ",");
      }
      const amount = properties[6].split(",");
      const factors = properties[7].split(",");
      const pdfs = properties[8].split(",");
      for (let i = 0; i < nrs.length; i++) {
        const ticket: Ticket = {
          nr: +nrs[i],
          walletReferenceId: walletReferences[i] || "",
          valid_date_start_ymd: +valid_date_start_ymd[i],
          valid_date_end_ymd: +valid_date_end_ymd[i],
          valid_date_start_hms: +valid_date_start_hms[i],
          valid_date_end_hms: +valid_date_end_hms[i],
          label: labels[i],
          amount: +amount[i],
          factor: +factors[i],
          pdf: pdfs[i],
          isActive: item.walletactive
        };
        tickets.push(ticket);
      }
    }
    return tickets;
  }

  private setBonusPoints() {
    const me = this;
    const bonuspoints = WebVoucherService.parseNewBonusPointsFromBonusPointString(me.checkoutpaymentmodel.BonuspointsVersion, me.checkoutpaymentmodel.BonuspointsForParsing);
    if (bonuspoints) {
      me.bonuspointsHTMLs = bonuspoints.map((bonus) => {
        const pointstext = this._coreLanguageService.value((bonus.points === 1) ? "phOrderResult_Point" : "phOrderResult_Points");
        return _.escape(this._coreLanguageService.value("phOrderResult_CollectedPointsForBonus_BASE"))
          .replace("{points}", `<span class="emphasized">${bonus.points} ${pointstext}</span>`)
          .replace("{bonusaction}", `<span class="emphasized">${bonus.label_de}</span>`);
      });
    }
  }

  public gotoHome() {
    const me = this;
    me._router.navigate(["/"]);
  }

  public returnToCheckout() {
    const me = this;
    // TODO Make it skip to checkout instead of basket
    me._router.navigate(["/webshop"]);
  }

}
